import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { Device } from '@/models/Device.ts'
import type { User } from '@/models/User.ts'

export const useTopbarStore = defineStore('topbar', () => {
  const customerSelected = ref<User | null>(null)
  const deviceSelected = ref<Device | null>(null)

  function reset() {
    customerSelected.value = null
    deviceSelected.value = null
  }

  return {
    customerSelected,
    deviceSelected,
    reset
  }
})
